import React, { Component } from 'react';
import { string } from 'prop-types';

import './Disclosure.scss';
class Disclosure extends Component {
  static propTypes = {
    text: string
  };

  render() {
    const { text } = this.props;

    return (
      <div className="pxl-text-xsmall disclosure__container">
        <div className="icon-reverse icon-circle disclosure__icon">
          <i className="icon-info" />
        </div>
        <p className="pxl-text-xsmall disclosure__text">{text}</p>
      </div>
    );
  }
}

export default Disclosure;
